import { Paragraph } from '@/components/atoms';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface KeyValuePairProps {
  label: string;
  value: ReactNode;
  direction?: 'row' | 'column';
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

export const KeyValuePair = ({
  label,
  value,
  direction = 'column',
  className,
  labelClassName,
  valueClassName,
}: KeyValuePairProps) => {
  return (
    <div
      className={cn(
        'flex',
        direction === 'column'
          ? 'flex-col gap-1'
          : 'flex-row items-center gap-2',
        className
      )}
    >
      <Paragraph className={cn('text-xs text-gray-500', labelClassName)}>
        {label}
      </Paragraph>
      <div className={cn('font-semibold capitalize', valueClassName)}>
        {value}
      </div>
    </div>
  );
};
